import { IGenericAnalysis, OmniaDialogSize, SoilAnalysisType } from "../../omnia"
import { getSsmAttributesAsMap } from "../../ssm/attrs"
import { getSsmGaugeStyle } from "../../ssm/colors"
import { getSsmColumns } from "../../ssm/columns"
import { SsmAttribute } from "../../ssm/types"
import { IAnalysisValueColumn, ISoilService } from "../../types"
import { TableColumns } from "../columns"
import { RowViewModel } from "../rowViewModel"
import { TableView } from "../view"

/// <reference path="../view.ts" />

interface ISsmColumn extends IAnalysisValueColumn {
    ssm: SsmAttribute
}

export class SsmViews extends TableView {

    static create(svc: ISoilService): SsmViews {
        const attributes = getSsmAttributesAsMap(svc.getSsmClassification())

        const columns = getSsmColumns().map(c => ({
            ...c,
            ssm: attributes.get(c.name)
        }))

        return new SsmViews(columns)
    }

    private constructor(columns: ISsmColumn[]) {

        super(false, false, false, [new SsmView(columns), new SsmFieldAllocView(columns)])

        this._key = this._template = "groupssm"
        this._name = "SSM analysis"

    }
}

export class SsmView extends TableView {

    constructor(private readonly columns: ISsmColumn[], allocations = false) {
        super(false, allocations, false)
        this._key = this._template = "ssm"
        this._name = "List"
    }


    getAnalyses(svc: ISoilService): IGenericAnalysis[] {
        return svc.getSoilAnalyses(SoilAnalysisType.SSM)
    }

    get analysisColumns(): IAnalysisValueColumn[] {
        return this.columns
    }

    getColumnsPopupConfig(columns: TableColumns) {
        return getColumnsPopupConfig(columns, this.columns)
    }

    getGaugeStyle(col: ISsmColumn, value: number, row: RowViewModel) {


        if ((!col.gauge) && col.ssm && col.ssm.hasClassification) {

            if (col.key === "OrganicMatter") {
                value = row.analysis[col.name] * 100
            }

            return getSsmGaugeStyle(col.ssm.getClass(value)?.ClassId)

        }

        return super.getGaugeStyle(col, value, row)

    }

    get editComponent() {
        return "omnia-soil-editor-ssm"
    }

    get editPopupSize() {
        return "full-screen" as OmniaDialogSize
    }

    get editPopupClass() {
        return "omnia-soil-editor-ssm-modal"
    }

}

export class SsmFieldAllocView extends SsmView {

    constructor(columns: ISsmColumn[]) {
        super(columns, true)
        this._key = this._template = this._template = "ssm-field-alloc"
        this._name = "Allocations"
    }

}


function getColumnsPopupConfig(columns: TableColumns, ssmColumns: ISsmColumn[]) {

    return {
        columns: [
            columns.field,
            columns.number,
            columns.date,
            columns.alloc
        ],
        analysisColumns: ssmColumns
    }
}

